export default __webpack_public_path__ + "static/media/baucknecht.a56c7995.svg";